import React from "react";

type SuccessModalProps = {
  isVisible: boolean;
  onClose: () => void;
};

const ManualOnboardSuccessModal: React.FC<SuccessModalProps> = ({
  isVisible,
  onClose,
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[100] bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-8 shadow-lg text-center max-w-md w-full mx-4">
        <h2 className="text-2xl font-bold text-green-600 mb-4">
          Profile Created Successfully!
        </h2>
        <p className="text-gray-600 mb-6">
          The candidate profile has been created. Please inform the candidate to check their email and follow the instructions to complete their onboarding.
        </p>
        <button
          className="px-8 py-2 bg-red font-bold text-white rounded-md w-full"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ManualOnboardSuccessModal;
